(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initShippingStrips(){
    document.querySelectorAll('[data-sereva-shipping]').forEach(function(strip){
      if(strip.dataset.shippingReady)return;
      strip.dataset.shippingReady='true';
      var button=strip.querySelector('.sereva-shipping-strip__toggle');
      if(!button)return;
      button.addEventListener('click',function(){
        var paused=strip.dataset.paused!=='true';
        strip.dataset.paused=String(paused);
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
        button.querySelector('span').textContent=paused?'▶':'Ⅱ';
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initShippingStrips);else initShippingStrips();
  document.addEventListener('shopify:section:load',initShippingStrips);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
